import { render } from "./MarketStatusBadge.vue?vue&type=template&id=8c864506&scoped=true"
import script from "./MarketStatusBadge.vue?vue&type=script&lang=js"
export * from "./MarketStatusBadge.vue?vue&type=script&lang=js"

import "./MarketStatusBadge.vue?vue&type=style&index=0&id=8c864506&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c864506"]])

export default __exports__